export default __webpack_public_path__ + "static/media/rpl8.f5ba0b4d.jpg";